import { AxialPoint } from "./AxialPoint";
import { CubePoint } from "./CubePoint";
import { POLYGON_RADIUS } from "./Shape";
import { OffsetPoint } from "./OffsetPoint";
export var PixelPoint;
(function (PixelPoint) {
    PixelPoint.create = (pointOrX, y) => (typeof pointOrX === 'number')
        ? ({ x: pointOrX, y: y })
        : pointOrX;
    // Conversions
    PixelPoint.toAxialPoint = ({ x, y }) => AxialPoint.create({
        q: (2 / 3 * x) / POLYGON_RADIUS,
        r: ((-1 / 3 * x) + (Math.sqrt(3) / 3 * y)) / POLYGON_RADIUS,
    });
    PixelPoint.toCubePoint = (point) => AxialPoint.toCubePoint(PixelPoint.toAxialPoint(point));
    PixelPoint.toOffsetPoint = (point) => AxialPoint.toOffsetPoint(PixelPoint.toAxialPoint(point));
    // Arithmetic
    PixelPoint.add = (p1, p2) => PixelPoint.create({
        x: p1.x + p2.x,
        y: p1.y + p2.y,
    });
    PixelPoint.negate = ({ x, y }) => PixelPoint.create({ x: -x, y: -y });
    PixelPoint.subtract = (p1, p2) => PixelPoint.add(p1, PixelPoint.negate(p2));
    // Comparison
    PixelPoint.lessThanOrEqual = (p1, p2) => p1.x <= p2.x && p1.y <= p2.y;
    // Vectors
    PixelPoint.clampX = ({ x }) => PixelPoint.create({ x, y: 0 });
    PixelPoint.clampY = ({ y }) => PixelPoint.create({ x: 0, y });
    // Rounded Conversions
    PixelPoint.toRoundedAxialPoint = (point) => AxialPoint.round(PixelPoint.toAxialPoint(point));
    PixelPoint.toRoundedCubePoint = (point) => CubePoint.round(PixelPoint.toCubePoint(point));
    PixelPoint.toRoundedOffsetPoint = (point) => OffsetPoint.round(PixelPoint.toOffsetPoint(point));
    // Utilities
    PixelPoint.toBoundingRect = (p1, p2) => ({
        topLeft: PixelPoint.create(Math.min(p1.x, p2.x), Math.min(p1.y, p2.y)),
        bottomRight: PixelPoint.create(Math.max(p1.x, p2.x), Math.max(p1.y, p2.y)),
    });
})(PixelPoint || (PixelPoint = {}));
//# sourceMappingURL=PixelPoint.js.map